<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col sm="12">
      <transition name="slide">
      <b-card>
        <div slot="header">
          <div class="row pl-2 pr-2">
            <b-col sm="12" lg="9" class=" p-1 title">
              <span>Usuários Varejo</span>
            </b-col>
            <b-col sm="12" lg="2" class="input-group input-group-sm p-1">
              <input class="form-control input-txt" id="txt-search" type="text" name="txt-search" v-model="searchValue" v-on:keyup.enter="search">
              <span class="input-group-append">
                <button id="btn-search" class="btn btn-success" type="button" @click="search" @click.stop.prevent><i class="fa fa-search"></i></button>
              </span>
            </b-col>
            <b-col sm="12" lg="1" class="p-1">
              <b-button type="button" size="sm" variant="success" class="btn-novo form-control" @click="userNew">Novo</b-button>
            </b-col>
          </div>
        </div>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" @row-clicked="rowClicked">
          <template slot="id" slot-scope="data">
            <strong>{{data.item.id}}</strong>
          </template>
          <template slot="username" slot-scope="data">
            <strong>{{data.item.username}}</strong>
          </template>
          <template slot="vencimento" slot-scope="data">{{data.item.billingLimits && data.item.billingLimits.limitRules.dueDate && formatDate(data.item.billingLimits.limitRules.dueDate.date)}}</template>
          <template slot="assinaturas" slot-scope="data">{{data.item.billingLimits && data.item.billingLimits.limitRules && data.item.billingLimits.limitRules.signature}}</template>
          <template slot="autenticacoes" slot-scope="data">{{data.item.billingLimits && data.item.billingLimits.limitRules && data.item.billingLimits.limitRules.login}}</template>
          <template slot="tipo" slot-scope="data">{{data.item.userType}}</template>
          <template slot="serial" slot-scope="data">{{data.item.serialNumber}}</template>
          <template slot="status" slot-scope="data">
            <b-badge :variant="getBadge(data.item)" :title="getStatusDetail(data.item.status)">{{getStatusValue(data.item.status)}}</b-badge>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" @change="paginationChanged" prev-text="<<" next-text=">>" hide-goto-end-buttons/>
        </nav>
      </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env, formatDate, normalizeRetailUserCredits } from '@/shared/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'Users',
  components: {
    Loading
  },
  props: {
    caption: {
      type: String,
      default: 'Usuários'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      items: [],
      fields: [
        {key: 'username', label: 'CPF/CNPJ'},
        {key: 'vencimento', label: 'Vencimento'},
        {key: 'assinaturas', label: 'Assinaturas'},
        {key: 'autenticacoes', label: 'Autenticações'},
        {key: 'userType', label: 'Tipo'},
        {key: 'serialNumber', label: 'SN'},
        {key: 'status'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      itemsByPage: {},
      searchValue: "",
      loadCount: 0,
    }
  },
  mounted() {
    this.getUsers();
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    },
    corporationSelected() {
      return this.$store.state.corporationSelected;
    }
  },
  watch: {
    corporationSelected(corporation) {
      this.getUsers();
    }
  },
  methods: {
    formatDate (date, format) {
      return formatDate(date, (format || "dd/MM/yyyy"));
    },
    normalizeRetailUsers (items = []) {
      return items.map((item) => normalizeRetailUserCredits(item));
    },
    getBadge (item) {
      switch (item.status) {
        case 0:
          return 'success'
        default:
          return 'danger'
      }
    },
    getStatusValue (status) {
      if (status == 0) {
        return "Ativo";
      }
      if ((status & 8) > 0) {
        return "Bloqueado"
      }
      return "Bloqueado"
    },
    getStatusDetail (status) {
      // const STATUS_ENABLED = 0;
      // const STATUS_DISABLED_USER = 1;
      // const STATUS_DISABLED_CORP = 2;
      // const STATUS_REMOVED = 4;
      // const STATUS_LOCKED = 8;
      var details = [];
      if (status == 0) {
        details.push("Ativo");
      } else {
        if ((status & 1) > 0) {
          return "Usuário";
        }
        if ((status & 2) > 0) {
          return "Corporação";
        }
        if ((status & 4) > 0) {
          return "Removed";
        }
        if ((status & 8) > 0) {
          return "Bloqueado";
        }
      }
      return details.join(", ");
    },
    rowClicked (item) {
      this.$router.push({path: `users-retail/edit/${item.id}`})
    },
    paginationChanged (pageNumber) {
      this.getUsers(pageNumber, this.searchValue);
    },
    search () {
      this.getUsers(1, this.searchValue);
    },
    userNew () {
      this.$router.push('users-retail/new');
    },
    getUsers (page = 1, search = "") {
      var cacheKey = search + page;
      if (this.itemsByPage[cacheKey]) {
        this.items = this.itemsByPage[cacheKey];
        this.currentPage = page;
        return;
      }
      var _this = this;
      this.loadCount++;
      axios
        .get(`${env.urlBillingApi}/user-retail?page=${page}&search=${search}`)
        .then(function(response) {
          _this.items = _this.normalizeRetailUsers(response.data._embedded.user_retail || []);
          _this.currentPage = Math.max(response.data.page, 1);
          _this.itemsByPage[search + _this.currentPage] = _this.items;
          _this.perPage = response.data.page_size;
          _this.totalRows = response.data.total_items;
        })
        .catch(function(error) {
          requestError(error);
        })
        .finally(() => {
          _this.loadCount--;
        });
    }

  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.search-area {
  max-width: 280px;
}
.input-txt {
  height: 32px !important;
}


@media screen and (max-width: 468px) {
  .title {
    text-align: center;
  }
}
</style>
